import React from 'react';
import { Wallet, Smartphone, Clock } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-12 px-4 bg-[#1e3a5f] text-white" data-id="element-195">
      <div className="max-w-4xl mx-auto" data-id="element-196">
        <div className="text-center mb-10" data-id="element-197">
          <span className="inline-block py-1 px-3 rounded-full bg-[#e63946] text-white text-sm font-bold tracking-wider mb-3" data-id="element-198">
            LA SOLUCIÓN
          </span>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-199">
            Método Doble Control 4×4
          </h2>
          <p className="text-lg text-blue-100 max-w-2xl mx-auto" data-id="element-200">
            Un sistema hecho para mamás reales que necesitan paredes firmes, no
            fuerza de voluntad.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-201">
          <div className="bg-white/10 backdrop-blur-sm p-5 rounded-2xl border border-white/20" data-id="element-202">
            <div className="flex items-center gap-3 mb-3" data-id="element-203">
              <div className="bg-white text-[#1e3a5f] w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-204">
                <Wallet className="h-4 w-4" data-id="element-205" />
              </div>
              <h3 className="text-base font-bold text-[#e63946]" data-id="element-206">
                Pared 1: 4 Sobres Físicos
              </h3>
            </div>
            <p className="text-blue-100 text-sm" data-id="element-207">
              Para lo variable. Porque el efectivo se siente. Y cuando se
              siente, se respeta.
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-5 rounded-2xl border border-white/20" data-id="element-208">
            <div className="flex items-center gap-3 mb-3" data-id="element-209">
              <div className="bg-white text-[#1e3a5f] w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-210">
                <Smartphone className="h-4 w-4" data-id="element-211" />
              </div>
              <h3 className="text-base font-bold text-[#e63946]" data-id="element-212">
                Pared 2: 4 Topes Digitales
              </h3>
            </div>
            <p className="text-blue-100 text-sm" data-id="element-213">
              Para lo inevitable. No vas a dejar Yape/Plin. Solo que ahora no te
              va a manejar a ti.
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-5 rounded-2xl border border-white/20" data-id="element-214">
            <div className="flex items-center gap-3 mb-3" data-id="element-215">
              <div className="bg-white text-[#1e3a5f] w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-216">
                <Clock className="h-4 w-4" data-id="element-217" />
              </div>
              <h3 className="text-base font-bold text-[#e63946]" data-id="element-218">
                El Pegamento: Corte Semanal
              </h3>
            </div>
            <p className="text-blue-100 text-sm" data-id="element-219">
              12 minutos a la semana. No para castigarte. Para corregir antes de
              que sea tarde.
            </p>
          </div>
        </div>
      </div>
    </section>;
}